import $ from 'jquery'
import '../../scripts/util/bootstrap-toolkit'

$(document).ready(function() {
  equalHeight('.dhsv_vc_home_teasers', '.js-first-box')
  equalHeight('.dhsv_vc_home_teasers', '.js-home-teasers')
  equalHeight('.dhsv_vc_home_teasers', '.js-home-teasers-title h3')
  dhsv_vc_home_teasers()
})

function equalHeight(parentNode, node) {
  const currentBreakpoint = window.bootstrapToolkit.current()
  if (currentBreakpoint !== 'sm' && currentBreakpoint !== 'xs') {
    $(parentNode).each(function() {
      let highestBox
      const elementNode = $(this)
        .closest('.row')
        .find(node)
      if ($(elementNode).length > 1) {
        highestBox = 0
      }
      $(elementNode).each(function() {
        if ($(this).outerHeight() > highestBox) {
          highestBox = $(this).outerHeight()
        }
      })
      $(elementNode).height(highestBox)
    })
  }

  $(window).resize(function() {
    const currentBreakpoint = window.bootstrapToolkit.current()
    if (currentBreakpoint === 'sm' || currentBreakpoint === 'xs') {
      $(node).css('height', 'auto')
    }
  })
}

function dhsv_vc_home_teasers() {
  $('.dhsv_vc_home_teasers').each(function() {
    $('.js-teasers-slider', this).slick({
      arrows: false,
      dots: true,
      infinite: false,
    })
  })
}
